const isRealNumber = (_num) => {
  return !isNaN(_num);
};

export { isRealNumber };
